import { MenuNode, menuNodesToSimpleMenuItems } from "components/LinksMenu/MenuNode";
import { SimpleMenu, useMenuState } from "@octopusdeploy/design-system-components";
import * as React from "react";

interface LinksMenuProps {
    items: MenuNode[];
    label?: string;
    icon?: string;
    activeItemClassName?: string;
}

const LinksMenu: React.FC<LinksMenuProps> = ({ items, label, icon, activeItemClassName }) => {
    const [onClick, menuState, ariaAttrs] = useMenuState();
    const simpleItems = menuNodesToSimpleMenuItems(items, menuState.onClose);

    return <>
        <a
            onClick={(e) => { e.preventDefault(); onClick(e); }}
            href="#"
            className={activeItemClassName}
            {...ariaAttrs}
        >
            {icon && <em className={icon} />}
            {!icon && <span>{label}</span>}
            {!icon && <em className="fa fa-caret-down" />}
        </a>
        <SimpleMenu
            menuState={menuState}
            items={simpleItems}
            accessibleName={label || "Links menu"}
        />
    </>;
};

export { LinksMenu };
export default LinksMenu;
